import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAllowSaleProductList(params) {
  return request({
    url: URL.sys.allowSaleProduct,
    method: 'get',
    params
  })
}

export function saveAllowSaleProduct(data) {
  return request({
    url: URL.sys.allowSaleProduct,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

// 失效和启用
export function enableOrNot(data) {
  return request({
    url: URL.sys.enableOrNot,
    method: 'post',
    data
  })
}
